import { render, staticRenderFns } from "./CourierRuleLogs.vue?vue&type=template&id=9d123918"
import script from "./CourierRuleLogs.vue?vue&type=script&lang=js"
export * from "./CourierRuleLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports